<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
    page: {
        title: "Diğer Ayarlar",
    },
    data() {
        return {
            submitted:false,
            submitted2:false,
            invoice:{},
            extra:{},
            domains:[]
        };
    },
    validations: {
        invoice:{
            kdv: { required },
            oiv: { required },
            unpaind_invoice_count: { required },
            last_payment_day: { required },
        },
    },
    mounted() { this.getList() },
    methods: {
        getList(){
            this.$http.get('/settings/invoice,extra')
            .then(resp => {
                this.invoice = resp.data.invoice
                this.domains = resp.data.extra.domains.split(',')
            }) .catch(error => error)
        },
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.$http.put('/settings/invoice', this.form)
                .then(resp => {
                    notify.success(resp.data.message)
                }) .catch(error => error)
            }
            this.submitted = false;
        },
        handleExtraSubmit(){
            this.submitted2 = true;
            //boş kayıt edebilir
    
            this.$http.put('/settings/extra',{ domains: this.domains.join(',')})
            .then(resp => {
                notify.success(resp.data.message)
            }) .catch(error => error)
       
            this.submitted2 = false;
        }
    }
};
</script>

<template>
<div class="row">
    <div class="col-6">
        <div class="card">
            <div class="card-body">
                <form class="needs-validation" @submit.prevent="handleSubmit">
                   <div class="row">
                    <div class="md-6">
                        <b-form-group
                            class="mb-3"
                            label="Ödenmemiş fatura izni"
                            label-cols-sm="5"
                        >
                            <b-form-input
                                v-model="invoice.unpaind_invoice_count"
                                type="text"
                                placeholder="Ödenmemiş fatura izni"
                                :class="{
                                    'is-invalid': submitted && $v.invoice.unpaind_invoice_count.$error,
                                }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.invoice.unpaind_invoice_count.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.invoice.unpaind_invoice_count.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        <b-form-group
                            class="mb-3"
                            label="Kdv Oranı"
                            label-cols-sm="5"
                            >
                            <b-form-input
                                v-model="invoice.kdv"
                                type="text"
                                placeholder="Kdv Oranı"
                                :class="{
                                    'is-invalid': submitted && $v.invoice.kdv.$error,
                                }"
                            >
                            </b-form-input>
                            <div
                                v-if="submitted && $v.invoice.kdv.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.invoice.kdv.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                         <b-form-group
                            class="mb-3"
                            label="Oiv Oranı"
                            label-cols-sm="5"
                            >
                            <b-form-input
                                v-model="invoice.oiv"
                                type="text"
                                placeholder="Oiv Oranı"
                                :class="{
                                    'is-invalid': submitted && $v.invoice.oiv.$error,
                                }"
                            >
                            </b-form-input>
                            <div
                                v-if="submitted && $v.invoice.oiv.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.invoice.oiv.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                         <b-form-group
                            class="mb-3"
                            label="Son Ödeme + Gün"
                            label-cols-sm="5"
                            >
                            <b-form-input
                                v-model="invoice.last_payment_day"
                                type="text"
                                placeholder="Son Ödeme + Gün"
                                :class="{
                                    'is-invalid': submitted && $v.invoice.last_payment_day.$error,
                                }"
                            >
                            </b-form-input>
                            <div
                                v-if="submitted && $v.invoice.last_payment_day.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.invoice.last_payment_day.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3 d-flex justify-content-end">
                                <button class="btn btn-warning" type="submit">Güncelle</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="card">
            <div class="card-body">
                <form class="needs-validation" @submit.prevent="handleExtraSubmit">
                   <div class="row">
                    <div class="md-6">
                        <b-form-group
                            class="mb-3"
                            label="Domainler"
                            label-cols-sm="5"
                        >
                            <v-select
                                v-model="domains"
                                :taggable="true"
                                :multiple="true"
                                :options="domains"
                            >
                            </v-select>
                            <div
                                v-if="submitted && $v.extra.domains.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.extra.domains.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3 d-flex justify-content-end">
                                <button class="btn btn-warning" type="submit">Güncelle</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>